var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%" },
            attrs: { type: "card" },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _vm.branchTransactions
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      lazy: true,
                      label: _vm.$t("SeaExport.branchTransactions"),
                      name: "branchTransactions"
                    }
                  },
                  [_c("branch-transactions")],
                  1
                )
              : _vm._e(),
            _vm.supplierCharge
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      lazy: true,
                      label: _vm.$t("SeaExport.supplierCharge"),
                      name: "supplierCharge"
                    }
                  },
                  [_c("supplier-charge")],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }